import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "grey-form-card"
}
const _hoisted_2 = { class: "card-parent" }
const _hoisted_3 = { class: "small-grey" }
const _hoisted_4 = {
  key: 0,
  class: "absolute-buttons"
}
const _hoisted_5 = { class: "card-row" }
const _hoisted_6 = { class: "card-label" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Subject ID:")
const _hoisted_8 = { class: "card-value" }
const _hoisted_9 = { class: "card-row" }
const _hoisted_10 = { class: "card-label" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Site:")
const _hoisted_12 = { class: "card-value" }
const _hoisted_13 = { class: "card-row" }
const _hoisted_14 = { class: "card-label" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Sex:")
const _hoisted_16 = { class: "card-value" }
const _hoisted_17 = { class: "card-row" }
const _hoisted_18 = { class: "card-label" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Year of birth:")
const _hoisted_20 = { class: "card-value" }
const _hoisted_21 = {
  key: 1,
  class: "card-row"
}
const _hoisted_22 = { class: "card-label" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Comment:")
const _hoisted_24 = { class: "card-value" }
const _hoisted_25 = {
  key: 1,
  class: "grey-form-card"
}
const _hoisted_26 = { class: "card-parent list-parent" }
const _hoisted_27 = { class: "small-grey" }
const _hoisted_28 = { class: "table-parent" }
const _hoisted_29 = { class: "paging-place" }
const _hoisted_30 = { class: "paging-label" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Showing ")
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" from ")
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" data ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EditIcon = _resolveComponent("EditIcon")
  const _component_el_button = _resolveComponent("el-button")
  const _component_UserIcon = _resolveComponent("UserIcon")
  const _component_CorporateFareIcon = _resolveComponent("CorporateFareIcon")
  const _component_SexMaleIcon = _resolveComponent("SexMaleIcon")
  const _component_CalendarTodayIcon = _resolveComponent("CalendarTodayIcon")
  const _component_CommentIcon = _resolveComponent("CommentIcon")
  const _component_TableHeaderComponent = _resolveComponent("TableHeaderComponent")
  const _component_router_link = _resolveComponent("router-link")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.profile)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("h6", _hoisted_3, "Subject " + _toDisplayString(_ctx.subject.subject_id), 1),
            (_ctx.forbidForRole(_ctx.UserRole.Analyst))
              ? (_openBlock(), _createBlock("div", _hoisted_4, [
                  _createVNode(_component_el_button, {
                    class: "single-button",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editSubject()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_EditIcon)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode(_component_UserIcon),
                _hoisted_7
              ]),
              _createVNode("div", _hoisted_8, _toDisplayString(_ctx.profile.subject_id), 1)
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                _createVNode(_component_CorporateFareIcon),
                _hoisted_11
              ]),
              _createVNode("div", _hoisted_12, _toDisplayString(_ctx.profile.site_name), 1)
            ]),
            _createVNode("div", _hoisted_13, [
              _createVNode("div", _hoisted_14, [
                _createVNode(_component_SexMaleIcon),
                _hoisted_15
              ]),
              _createVNode("div", _hoisted_16, _toDisplayString(_ctx.formatSex(_ctx.profile.sex_type)), 1)
            ]),
            _createVNode("div", _hoisted_17, [
              _createVNode("div", _hoisted_18, [
                _createVNode(_component_CalendarTodayIcon),
                _hoisted_19
              ]),
              _createVNode("div", _hoisted_20, _toDisplayString(_ctx.profile.year_of_birth), 1)
            ]),
            (_ctx.profile.comment)
              ? (_openBlock(), _createBlock("div", _hoisted_21, [
                  _createVNode("div", _hoisted_22, [
                    _createVNode(_component_CommentIcon),
                    _hoisted_23
                  ]),
                  _createVNode("div", _hoisted_24, _toDisplayString(_ctx.profile.comment), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.profile && _ctx.state.paging.total > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_25, [
          _createVNode("div", _hoisted_26, [
            _createVNode("h6", _hoisted_27, "Assessments (" + _toDisplayString(_ctx.state.paging.total) + ")", 1),
            _createVNode("div", _hoisted_28, [
              _withDirectives(_createVNode(_component_el_table, {
                class: "list-table",
                ref: "multipleTable",
                data: _ctx.list.data,
                style: {"width":"100%"},
                "header-row-class-name": "header-row",
                stripe: true,
                "empty-text": "Nothing is found."
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: "Date/Time",
                    "min-width": "150",
                    fixed: ""
                  }, {
                    header: _withCtx(() => [
                      _createVNode(_component_TableHeaderComponent, {
                        header: 'Date/Time',
                        sortable: true,
                        sortingValue: 
                    _ctx.getSortingValueForField(_ctx.fieldNames.assessment_time)
                  ,
                        onChangeSorting: _cache[2] || (_cache[2] = ($event: any) => (
                    _ctx.sortingChange(_ctx.fieldNames.assessment_time, $event)
                  ))
                      }, null, 8, ["sortingValue"])
                    ]),
                    default: _withCtx((scope) => [
                      _createVNode(_component_router_link, {
                        to: {
                    name: 'View HiPAL Pro',
                    params: {
                      id: _ctx.profile.id,
                      siteId: _ctx.profile.site_id,
                      assessmentId: scope.row.assessment_id,
                    },
                  }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.formatDate(
                      scope.row[_ctx.fieldNames.assessment_time],
                      _ctx.dateFormats.withTime
                    )), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "Predicted MMSE Score",
                    width: "220"
                  }, {
                    header: _withCtx(() => [
                      _createVNode(_component_TableHeaderComponent, {
                        header: 'Predicted MMSE Score',
                        sortable: true,
                        sortingValue: _ctx.getSortingValueForField(_ctx.fieldNames.score_mmse),
                        onChangeSorting: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sortingChange(_ctx.fieldNames.score_mmse, $event)))
                      }, null, 8, ["sortingValue"])
                    ]),
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(scope.row.score_mmse), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "Predicted ADAScog Score",
                    width: "220"
                  }, {
                    header: _withCtx(() => [
                      _createVNode(_component_TableHeaderComponent, {
                        header: 'Predicted ADAScog Score',
                        sortable: true,
                        sortingValue: 
                    _ctx.getSortingValueForField(_ctx.fieldNames.score_adascog)
                  ,
                        onChangeSorting: _cache[4] || (_cache[4] = ($event: any) => (
                    _ctx.sortingChange(_ctx.fieldNames.score_adascog, $event)
                  ))
                      }, null, 8, ["sortingValue"])
                    ]),
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(scope.row.score_adascog), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "Status",
                    "min-width": "240"
                  }, {
                    header: _withCtx(() => [
                      _createVNode(_component_TableHeaderComponent, {
                        header: 'Status',
                        sortable: true,
                        sortingValue: _ctx.getSortingValueForField(_ctx.fieldNames.status),
                        onChangeSorting: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sortingChange(_ctx.fieldNames.status, $event)))
                      }, null, 8, ["sortingValue"])
                    ]),
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(scope.row[_ctx.fieldNames.status]), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"]), [
                [_directive_loading, _ctx.state.isLoading]
              ]),
              _createVNode("div", _hoisted_29, [
                _createVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createVNode("span", null, _toDisplayString(_ctx.list.data.length), 1),
                  _hoisted_32,
                  _createVNode("span", null, _toDisplayString(_ctx.state.paging.total), 1),
                  _hoisted_33
                ]),
                (_ctx.state.paging.total > _ctx.state.paging.pageSize)
                  ? (_openBlock(), _createBlock(_component_el_pagination, {
                      key: 0,
                      class: "table-paging",
                      layout: "prev, pager, next",
                      "current-page": _ctx.state.paging.page,
                      "page-size": _ctx.state.paging.pageSize,
                      "pager-count": 5,
                      total: _ctx.state.paging.total,
                      onCurrentChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.pageChange($event)))
                    }, null, 8, ["current-page", "page-size", "total"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}